import React from "react";
import { HashRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import Routes from "./routes";
import { store, persistor } from "./store/store";
import { PersistGate } from "redux-persist/integration/react";
import SetAuthToken from "./helper/setAuthToken";
import "./app.css";
import { ThemeProvider } from "styled-components";
import { createTheme } from "@mui/material";

// Create a basic MUI theme
const theme = createTheme({
  palette: {
    mode: "light",
  },
});

const AuthTokenSetter = () => {
  SetAuthToken();
  return null;
};

const App = () => {
  return (
    <Provider store={store}>
      <PersistGate loading={<div>Loading...</div>} persistor={persistor}>
        <ThemeProvider theme={theme}>
          {" "}
          {/* Wrap with ThemeProvider */}
          <Router>
            <AuthTokenSetter />
            <Routes />
          </Router>
        </ThemeProvider>
      </PersistGate>
    </Provider>
  );
};

export default App;
